import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { SaleItem } from "@/models/sale-item.model"
import type { ISaleItem } from "@/interfaces/api/sale-item.interface"
import { SaleItemRepository } from "@/repositories/sale-item-repository"
import { useSaleItemStore } from "@/store/sale-items.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class SaleItemController extends GenericModelController<
  SaleItem,
  ISaleItem,
  SaleItemRepository
> {
  constructor() {
    const saleItemStore = useSaleItemStore()
    const { saleItems } = storeToRefs(saleItemStore)

    const storeFunctionsConfig = {
      collection: saleItems
    }

    super(SaleItem, storeFunctionsConfig, new SaleItemRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(SaleItem, saleItems)
  }
}
